<template>
  <div>
    <!--    <div>-->
    <!--      <SectionHeader></SectionHeader>-->
    <!--    </div>-->

    <!-- 视频list   -->
    <div class="pa-3">
      <v-card>
        <v-card-title>
          <v-tabs>
            <v-tab v-for="(item,index) in videoTypeList" :key="index" @click="changeTab(item.id)">
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <div v-if="videoListData.length !== 0">
            <video-list :list="videoListData"></video-list>
            <!--            <v-pagination-->
            <!--                @input="getVideoList"-->
            <!--                v-model="pageResult.currPage"-->
            <!--                :total-visible="6"-->
            <!--                class="my-4"-->
            <!--                :length="pageResult.totalPage"-->
            <!--            ></v-pagination>-->
          </div>
        </v-card-text>

      </v-card>

    </div>

    <!--弹窗    -->
    <div>
      <v-row justify="center">
        <v-dialog
            v-model="dialog"
            scrollable
            persistent
            max-width="300px">
          <v-card class="pa-3">
            <v-text-field v-model="secret"></v-text-field>
            <v-card-actions>
              <v-btn @click="setting">确定</v-btn>
              <v-btn @click="dialog=false">取消</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>


    <div>
      <!-- 右下角菜单-->
      <v-speed-dial
          class="mb-15"
          v-model="fab"
          bottom
          right
          fixed
          direction="top"
          transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <div>
            <div v-if="fab">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-model="fab" fab v-bind="attrs" v-on="on">
                    <v-icon color="red">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </template>
                <span>关闭</span>
              </v-tooltip>
            </div>

            <div v-if="!fab">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-model="fab" fab v-bind="attrs" v-on="on"
                  >
                    <v-icon>
                      menu
                    </v-icon>
                  </v-btn>
                </template>
                <span>菜单</span>
              </v-tooltip>
            </div>

            <!--            <div v-if="fab">-->
            <!--              <v-tooltip left>-->
            <!--                <template v-slot:activator="{ on, attrs }">-->
            <!--                  <v-btn v-model="fab" fab v-bind="attrs" v-on="on">-->
            <!--                    <v-icon>-->
            <!--                      fas fa-lock-->
            <!--                    </v-icon>-->
            <!--                  </v-btn>-->
            <!--                </template>-->
            <!--                <span>设置</span>-->
            <!--              </v-tooltip>-->
            <!--            </div>-->

          </div>
        </template>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">

            <v-btn @click="toHistory" fab v-bind="attrs"
                   v-on="on" class="pa-3" small>
              <v-icon color="#673AB7">
                mdi-history
              </v-icon>
            </v-btn>

          </template>
          <span>观看记录</span>
        </v-tooltip>


        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="dialog = true" fab v-bind="attrs"
                   v-on="on" class="pa-3" small>
              <v-icon color="#673AB7">
                mdi-cog
              </v-icon>
            </v-btn>

          </template>
          <span>设置</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="toSearch" fab v-bind="attrs"
                   v-on="on" class="pa-3" small>
              <v-icon color="#607D8B">
                search
              </v-icon>
            </v-btn>

          </template>
          <span>搜索</span>
        </v-tooltip>


      </v-speed-dial>

      <!-- 右下角回到顶部-->
      <back-top></back-top>
    </div>

  </div>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex';
import {index} from '@/api/resources/video'
// import SectionHeader from "@/components/video/SectionHeader";
import VideoList from '@/components/video/VideoList'
import BackTop from "@/components/BackTop";

export default {
  data: () => ({
    fab: false,
    keyword: undefined,
    dialog: false,
    videoTypeList: [],
    selectedItem: 0,
    nodeList: [],
    videoListData: [],
    typeId: undefined,
    pageResult: {
      currPage: 1,
    },
    secret: undefined

  }),
  computed: {
    ...mapGetters(['getKeyList', 'getSecret']),
    // getNodeName() {
    //   let node = this.getNodeList.find(item => item.node === this.getNode);
    //
    //   if (node) {
    //     return node.name;
    //   }
    //   return node;
    // }
  },
  mounted() {
    this.secret = this.getSecret
    this.initClassify()
  },
  components: {
    BackTop,
    // SectionHeader,
    VideoList
  },
  methods: {
    ...mapMutations(['setSecret', 'setNodeList', 'clearKeyList', 'delKeyList', 'setKeyList', 'setLoading', 'clearLoading']),

    // _getClassifyList() {
    //   getClassifyList().then(req => {
    //     let {data} = req.data
    //     this.nodeList = data
    //     this.setNodeList(data);
    //     this.dialog = true
    //   })
    // },
    setting() {
      if (this.secret) {
        this.setSecret(this.secret)
        this.dialog = false
      }
    },

    initClassify() {
      // if (!this.getNodeList || !this.getNode) {
      //   this._getClassifyList()
      // } else {
      //   this.getVideoType()
      // }
      this.setLoading();
      index(this.secret).then((req) => {
        this.videoTypeList = req.data.data;
        let {videoList} = this.videoTypeList[0]
        this.videoListData = videoList
      }).finally(() => {
        this.clearLoading();
      })
    },

    // getVideoType() {
    //   this.setLoading();
    //   send({
    //     url: this.getNode
    //   }).then((req) => {
    //     let {classify} = req.data.data;
    //     this.videoTypeList = classify
    //
    //     this.getVideoList();
    //
    //   }).finally(() => {
    //     this.clearLoading();
    //   })
    // },

    // getVideoList() {
    //   this.setLoading();
    //   send({
    //     url: this.getNode,
    //     params: {pg: this.pageResult.currPage, t: this.typeId, ac: "detail"}
    //   }).then((req) => {
    //     let {list, page, pagecount} = req.data.data;
    //
    //     this.pageResult = {
    //       currPage: page,
    //       totalPage: pagecount
    //     };
    //
    //     this.videoListData = list;
    //   }).finally(() => {
    //     this.clearLoading();
    //   })
    // },
    toPlayer({id}) {
      this.$router.push({
        path: '/video/info',
        query: {id: id}
      })
    },
    toSearch() {
      this.$router.push({
        path: '/video/search'
      })
    },
    // saveNode() {
    //   if (typeof (this.selectedItem) === "undefined") {
    //     return;
    //   }
    //   this.setNode(this.nodeList[this.selectedItem].url);
    //   this.getVideoList();
    //   this.dialog = false;
    // },
    changeTab(typeId) {
      // this.pageResult = {
      //   currPage: 1
      // }
      // this.typeId = typeId
      // this.getVideoList()

      let {videoList} = this.videoTypeList.find(item => item.id === typeId)
      this.videoListData = videoList
    },
    toHistory() {
      this.$router.push({
        path: '/video/history',
      })
    },
  }
}
</script>

<style scoped>
</style>
